(function () {
  'use strict';

  angular.module('app').component('associatedServiceItemDetail', associatedServiceItemDetail());

  function associatedServiceItemDetail() {
    return {
      bindings: {
        associatedServiceItem: '=',
        productType: '<',
        product: '<',
        onAssociatedServiceItemSaved: '&',
        onAssociatedServiceItemCanceled: '&',
      },
      controller: AssociatedServiceItemDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/service-items/associated-service-items/' +
        'associated-service-item-detail/associated-service-item-detail.component.html',
    };
  }

  AssociatedServiceItemDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AssociatedServiceItemService',
  ];

  function AssociatedServiceItemDetailComponent(config, UtilService, AssociatedServiceItemService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    // Methods
    vm.checkAllSchedules = checkAllSchedules;
    vm.validateCheckedSchedules = validateCheckedSchedules;

    vm.saveAssociatedServiceItem = saveAssociatedServiceItem;
    vm.cancel = cancel;

    vm.$onInit = function () {
      vm.saveButtonLabel = 'UPDATE';
      vm.invalidSchedules = true;

      if (vm.productType === 'tour') {
        setTourOptions();
        validateCheckedSchedules();
      }
    };

    function checkAllSchedules() {
      var isEnabled = vm.allSchedulesChecked || false;

      vm.tourOptions.forEach(function (option) {
        option.schedules.forEach(function (schedule) {
          schedule.enabled = isEnabled;
        });
      });

      validateCheckedSchedules();
    }

    function validateCheckedSchedules() {
      vm.invalidSchedules = true;

      var option, schedule;
      for (var i = 0; i < vm.tourOptions.length; i++) {
        option = vm.tourOptions[i];

        for (var j = 0; j < option.schedules.length; j++) {
          schedule = option.schedules[j];

          if (schedule.enabled) {
            vm.invalidSchedules = false;
            return;
          }
        }
      }
    }

    function setTourOptions() {
      vm.tourOptions = [];

      var option, schedule;
      vm.product.tour_options.forEach(function (tourOption) {
        option = {
          name: tourOption.name,
          status: tourOption.status,
          schedules: [],
        };

        tourOption.tour_option_schedules.forEach(function (tourOptionSchedule) {
          schedule = {
            tour_id: vm.product.id,
            tour_option_id: tourOption.id,
            tour_option_schedule_id: tourOptionSchedule.id,
            departure: tourOptionSchedule.departure,
            status: tourOptionSchedule.status,
            enabled: false,
          };

          if (vm.associatedServiceItem.associated_service_item_schedules) {
            for (
              var i = 0;
              i < vm.associatedServiceItem.associated_service_item_schedules.length;
              i++
            ) {
              var itemSchedule = vm.associatedServiceItem.associated_service_item_schedules[i];

              if (itemSchedule && itemSchedule.tour_option_schedule_id === tourOptionSchedule.id) {
                schedule.id = itemSchedule.id;
                schedule.enabled = itemSchedule.enabled;
                break;
              }
            }
          }

          option.schedules.push(schedule);
        });

        vm.tourOptions.push(option);
      });
    }

    function setAssociatedServiceItemSchedules(tourOptions) {
      var associatedServiceItemSchedules = [];

      tourOptions.forEach(function (option) {
        option.schedules.forEach(function (schedule) {
          delete schedule.$$hashKey;
          associatedServiceItemSchedules.push(schedule);
        });
      });

      return associatedServiceItemSchedules;
    }

    // Create/Update
    function saveAssociatedServiceItem(isFormValid) {
      var item = {
        id: vm.associatedServiceItem.id,
        provider_id: vm.associatedServiceItem.provider_id,
        product_associated_id: vm.associatedServiceItem.product_associated_id,
        service_item_id: vm.associatedServiceItem.service_item_id,
        associated_service_item_schedules: null,
      };

      if (vm.productType === 'tour') {
        item.associated_service_item_schedules = setAssociatedServiceItemSchedules(vm.tourOptions);
      }

      if (!isFormValid) {
        vm.formErrors = true;
      } else {
        vm.sendingForm = true;

        AssociatedServiceItemService.saveAssociatedServiceItem(item, vm.productType).then(function (
          data
        ) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            if (vm.productType === 'tour') {
              vm.associatedServiceItem.appliedTo = response.appliedTo;
              vm.associatedServiceItem.associated_service_item_schedules =
                response.associated_service_item_schedules;

              setTourOptions();
            }

            vm.onAssociatedServiceItemSaved({ item: response });
          } else {
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      }
    }

    function cancel() {
      vm.onAssociatedServiceItemCanceled({ item: vm.item });
    }
  }
})();
